import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import appInsights from "./appInsights"
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles"
import { createTheme } from "@mui/material/styles"
import { MuiCostcoTheme } from "@costcolabs/forge-components"
import Divider from "@mui/material/Divider"

import Header from "./header"
import "./layout.css"
import Footer from "./footer"

appInsights.trackPageView()

const Layout = ({ children, site }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  const customTheme = React.useMemo(() => {
    const baseTheme = MuiCostcoTheme
    const costcoSansFont = "'CostcoSans', sans-serif"

    const typographyOverrides = Object.entries(baseTheme.typography).reduce(
      (acc, [key, value]) => {
        if (typeof value === "object") {
          acc[key] = { ...value, fontFamily: costcoSansFont }
        }
        return acc;
      },
      {}
    )

    return createTheme({
      ...baseTheme,
      typography: {
        ...baseTheme.typography,
        fontFamily: costcoSansFont,
        caption: {
          fontSize: "", // required for stepper to work
        },
        ...typographyOverrides,
      },
      components: {
        ...baseTheme.components,
        MuiCssBaseline: {
          styleOverrides: `
            * {
              font-family: 'CostcoSans', sans-serif !important;
            }
          `,
        },
      },
    })
  }, [])

  return (
    <>
      {/* <div style={{display:"block"}}> */}
      <MuiThemeProvider theme={customTheme}>
        <Header
          siteTitle={data.site.siteMetadata?.title || `Title`}
          site={site}
        />
        <Divider orientation="horizontal" aria-hidden="true" />
        <div
          className="maincontent"
          role="main" // Indicate this is the main content of the page
        >
          <main aria-label="Scheduling wizard">{children}</main>
        </div>
        <Footer aria-label="Footer" />
      </MuiThemeProvider>
      {/* </div> */}
    </>
  )
}

export default Layout
